import { render, staticRenderFns } from "./SiteVersionCreate.vue?vue&type=template&id=dfc5a1dc&lang=pug"
import script from "./SiteVersionCreate.vue?vue&type=script&lang=js"
export * from "./SiteVersionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports